<!-- 签单订单Excel导入 -->
<template>
	<div>
		<el-form ref="form" label-width="120px" size="medium">
			<el-form-item required label="平台">
				<el-col :span="12">
					<el-select v-model="create_data.platform" clearable placeholder="请选择">
						<el-option v-for="item in platform_list" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-col>
			</el-form-item>
			<el-form-item required label="国家">
				<el-col :span="12">
					<el-select v-model="create_data.country" clearable placeholder="请选择">
						<el-option v-for="item in country_list" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-col>
			</el-form-item>
			<el-form-item required label="发货类型">
				<el-col :span="12">
					<el-radio-group v-model="create_data.send_type">
						<el-tooltip class="item" effect="dark" content="仓库发货必须上传面单" placement="bottom">
							<el-radio :label="1">仓库发货</el-radio>
						</el-tooltip>
						<el-radio :label="2">商户发货</el-radio>
					</el-radio-group>
				</el-col>
			</el-form-item>
			<el-form-item label="分组">
				<el-col :span="12">
					<el-select v-model="create_data.group" clearable placeholder="请选择">
						<el-option v-for="item in group_list" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-col>
			</el-form-item>
			<el-form-item required label="Excel上传">
				<el-col :span="12">
					<ExcelUpload @imgList="excelU" :img_num="1" :img_edit="create_data.doc_url"></ExcelUpload>
				</el-col>
			</el-form-item>
		</el-form>

		<el-divider content-position="left">添加预览</el-divider>

		<el-button v-if="this.create_data.doc_url" type="warning" @click="docDo">开始导入</el-button>
		<span> 共 {{doc_data_count}} 单</span>
		<el-button type="danger" style="margin-left: 100px;" @click="delSuccess">删除已成功订单</el-button>
		<el-button type="success" style="margin-left: 100px;" @click="download">下载导入模板</el-button>

		<el-table :data="create_data.data" style="width: 100%">
			<el-table-column prop="shop_name" label="店铺名">
				<template slot-scope="{row,$index}">
					<el-input v-model="row.shop_name"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="order_number" label="订单号">
				<template slot-scope="{row,$index}">
					<el-input v-model="row.order_number"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="tn_number" label="运单号">
				<template slot-scope="{row,$index}">
					<el-input v-model="row.tn_number"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="price" label="金额">
				<template slot-scope="{row,$index}">
					<el-input-number v-model="row.price" :precision="2" :step="0.1"></el-input-number>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="收货地址">
				<template slot-scope="{row,$index}">
					<el-input type="textarea" v-model="row.address"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="pdf" label="上传PDF">
				<template v-if="create_data.send_type == 1" slot-scope="{row,$index}">
					<PdfUpload @imgList="pdfU($event,$index)" :img_num="1" :img_edit="row.doc_url"></PdfUpload>
				</template>
			</el-table-column>
			<el-table-column prop="msg" label="信息">
				<template slot-scope="{row,$index}">
					<span v-if="row.msg == '成功'" style="color: green;">{{row.msg}}</span>
					<span v-if="row.msg != '成功'" style="color: red;">{{row.msg}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="" label="操作">
				<template slot-scope="{row,$index}">
					<el-popconfirm @confirm="orderDel($index)" @onConfirm="orderDel($index)" title="确定删除？">
						<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
						</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<el-button v-if="create_data.data.length > 0" :loading="this.$store.state.ajaxLoading"
			style="margin-left: 45%;margin-top: 20px;" type="primary" @click="tj">提交</el-button>
	</div>
</template>

<script>
	import {
		orderAddBatch,
		doExcel
	} from '@/api/sign_shop';
	import {
		alertMsg,getBaseUrl
	} from '@/tool/index';
	import Qs from 'qs'
	import ExcelUpload from '@/components/Ele/excelUpload.vue'; // 上传excel组件
	import PdfUpload from '@/components/Ele/pdfUpload.vue' // 上传pdf组件
	export default {
		name: 'DocBatchAddExcel',
		components: {
			ExcelUpload,
			PdfUpload
		},
		data() {
			return {
				create_data: {},
				doc_data: {}
			}
		},
		computed: {
			doc_data_count() {
				return this.create_data.data.length;
			}
		},
		props: { // 定义组件的属性
			platform_list: {
				type: Array,
				default: [],
			},
			country_list: {
				type: Array,
				default: [],
			},
			group_list: {
				type: Array,
				default: [],
			},
			is_show_create_batch: {
				type: Boolean,
				default: false,
			}
		},
		watch: {
			is_show_create_batch() {
				this.resetCreateData()
			},
		},
		created() {
			this.resetCreateData()
		},
		methods: {
			resetCreateData() { // 重置create_data数据
				this.create_data = {
					platform: '',
					country: '',
					send_type: 1,
					group: '',
					doc_url: '',
					data: [],
				}
			},
			// Excel上传后的回调
			excelU(e, a) {
				this.create_data.doc_url = e[0].url;
			},
			// 开始导入
			docDo() {
				let post = {
					url: this.create_data.doc_url
				}
				doExcel(Qs.stringify(post)).then(response => {
					this.create_data.data = response.result;
				})
			},
			// 删除列表数据
			orderDel(index) {
				this.create_data.data.splice(index, 1);
			},
			// 删除已成功订单
			delSuccess() {
				let new_data = [];
				this.create_data.data.forEach((item, index) => {
					if (item.msg != '成功') {
						new_data.push(item);
					}
				});
				this.create_data.data = new_data;
			},
			// 提交订单
			tj() {
				if (!this.create_data.platform) {
					return alertMsg(this, '请先选择平台');
				}
				if (!this.create_data.country) {
					return alertMsg(this, '请先选择国家');
				}
				this.$store.commit('setAjaxLoading', true);
				let post = {
					data:JSON.stringify(this.create_data)
				}
				orderAddBatch(Qs.stringify(post)).then(response => {
					let r = response.result;
					this.create_data.data.forEach((item, index) => {
						try {
							r.forEach((item2, index2) => {
								if (item.order_number == item2.order_number) {
									this.create_data.data[index].msg = item2.msg;
									throw new Error("break");
								}
							});
						} catch (e) {
							if (e.message != "break") throw e;
						};
					});

					alertMsg(this, '提交成功', 'success');
				})
			},
			// 下载导入模板
			download() {
				let url = getBaseUrl() + "static/doc/templ.xls";
				window.open(url, "_blank");
			},
			// pdf上传后的回调
			pdfU(e,index){
				this.create_data.data[index].doc_url = e[0].url;
			},
		}
	}
</script>

<style>
	.el-col-12 {
		text-align: left;
	}
</style>
